module.exports = __webpack_public_path__ + "img/google_play_black.96882ac.png";